import styles from './styles.module.scss';
import moment from 'moment';
import { useState, useEffect } from 'react';

interface MonthPickerProps {
  value?: string; // YYYY-MM-DD
  onChange: ((dateString: string) => void) | ((direction: 'prev' | 'next') => void);
  disabled?: boolean;
  dateFrom?: Date | null;
  dateTo?: Date | null;
  useDirectionCallback?: boolean;
}

export const MonthSlider = ({
  value,
  onChange,
  disabled = false,
  dateFrom,
  dateTo,
  useDirectionCallback = false
}: MonthPickerProps) => {
  const [currentDate, setCurrentDate] = useState<moment.Moment>(
    value ? moment(value, 'YYYY-MM-DD') : moment().startOf('month')
  );

  useEffect(() => {
    if (value) {
      setCurrentDate(moment(value, 'YYYY-MM-DD'));
    }
  }, [value]);

  const handlePrevMonth = () => {
    if (disabled) return;
    if (useDirectionCallback) {
      (onChange as (direction: 'prev' | 'next') => void)('prev');
    } else {
      const newDate = currentDate.clone().subtract(1, 'month').startOf('month');
      setCurrentDate(newDate);
      (onChange as (dateString: string) => void)(newDate.format('YYYY-MM-DD'));
    }
  };

  const handleNextMonth = () => {
    if (disabled) return;
    if (useDirectionCallback) {
      (onChange as (direction: 'prev' | 'next') => void)('next');
    } else {
      const newDate = currentDate.clone().add(1, 'month').startOf('month');
      setCurrentDate(newDate);
      (onChange as (dateString: string) => void)(newDate.format('YYYY-MM-DD'));
    }
  };

  const getDisplayLabel = () => {
    if (dateFrom && dateTo) {
      const fromMoment = moment(dateFrom);
      const toMoment = moment(dateTo);
      if (fromMoment.month() !== toMoment.month() || fromMoment.year() !== toMoment.year()) {
        return `${fromMoment.format('MMMM')} - ${toMoment.format('MMMM YYYY')}`;
      }
      return fromMoment.format('MMMM YYYY');
    }
    return currentDate.format('MMMM YYYY');
  };

  return (
    <div className="d-flex user-select-none">
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={handlePrevMonth}
        className="cursor-pointer"
      >
        <path
          opacity="0.3"
          d="M18.8909 2.33594H9.11427C5.3707 2.33594 2.33594 5.3707 2.33594 9.11427V18.8909C2.33594 22.6345 5.3707 25.6693 9.11427 25.6693H18.8909C22.6345 25.6693 25.6693 22.6345 25.6693 18.8909V9.11427C25.6693 5.3707 22.6345 2.33594 18.8909 2.33594Z"
          fill="#A1A5B7"
        />
        <path
          d="M16.1295 9.83594L11.8828 13.9076L15.9545 18.1659"
          stroke="#A1A5B7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div className={styles.dateFilter}>{getDisplayLabel()}</div>

      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={handleNextMonth}
        className="cursor-pointer"
      >
        <path
          opacity="0.3"
          d="M9.10906 25.6641L18.8857 25.6641C22.6293 25.6641 25.6641 22.6293 25.6641 18.8857L25.6641 9.10906C25.6641 5.36549 22.6293 2.33073 18.8857 2.33073L9.10906 2.33073C5.36549 2.33073 2.33073 5.36549 2.33073 9.10906L2.33073 18.8857C2.33073 22.6293 5.36549 25.6641 9.10906 25.6641Z"
          fill="#A1A5B7"
        />
        <path
          d="M11.875 9.83594L16.1217 13.9076L12.05 18.1659"
          stroke="#A1A5B7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
